import "./NotificationsDrop.css"

import type { RefObject } from "react"

import { useMarkNotificationsAsReadMutation } from "@/queries/mutations/notificationMutations"
import type { Notification } from "@/types/notificationTypes"
import { useTranslation } from "react-i18next"
import NotificationsItem from "../NotificationsItem/NotificationsItem"

export default function NotificationsDrop({
  optionsRef,
  isOpen,
  realtimeData,
}: {
  optionsRef: RefObject<HTMLDivElement>
  isOpen: boolean
  realtimeData: (Notification & { firebaseKey?: string })[]
}) {
  const { t, i18n } = useTranslation()

  return (
    <div
      className={"notifications " + (isOpen ? "notifications--open" : "")}
      style={
        i18n.language === "en"
          ? {
              right: "30px",
              transformOrigin: "right top",
            }
          : {
              left: "30px",
              transformOrigin: "left top",
            }
      }
      ref={optionsRef}
    >
      <div className="text-start p-3">
        <h5 className="fw-bold mb-0">{t("notifications.drop.title")}</h5>
      </div>

      {realtimeData?.length ? (
        realtimeData.map((notification) => {
          return (
            <NotificationsData
              key={notification.id}
              notification={notification}
            />
          )
        })
      ) : (
        <h4 className="fw-bold text-center my-4">
          {t("notifications.drop.noData")}
        </h4>
      )}
    </div>
  )
}

function NotificationsData({
  notification,
}: {
  notification: Notification & { firebaseKey?: string }
}) {
  const markAsReadMutation = useMarkNotificationsAsReadMutation(notification.id)
  // const userId = useStore((store) => store.authData)?.user?.id

  return (
    <div
      key={notification.id}
      onClick={() => {
        markAsReadMutation.mutate({
          notification_id: notification.id,
        })
        // markAsRead(notification.firebaseKey, String(userId))
      }}
    >
      <NotificationsItem notification={notification} />
    </div>
  )
}

// function markAsRead(firebaseKey?: string, userId?: string) {
//   const db = getDatabase(app)
//   const notifRef = ref(db, `user_notifications/${userId}/${firebaseKey}`)
//   update(notifRef, {
//     is_read: true,
//     read_at: Math.floor(Date.now() / 1000),
//   })
// }
